class SampleProducts extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {

    this.counter = this.querySelector('.selected-count');
    if (!this.counter) return;
    this.maxAllowed = Number(this.counter.dataset.max);
        this.drawer =
      document.getElementById(
        'sampleDrawer'
      );

    this.overlay =
      document.getElementById(
        'drawerOverlay'
      );

    this.initSwiper();
    this.bindEvents();
    this.bindDrawer();
    this.updateDisabledState();

  }

  initSwiper() {

    new Swiper(
      this.querySelector('.freeSamplesSwiper'),
      {
        slidesPerView: 2,
        spaceBetween: 16,

        navigation:{
          nextEl:this.querySelector('.free-next'),
          prevEl:this.querySelector('.free-prev')
        },

        pagination:{
          el:this.querySelector('.swiper-pagination'),
          clickable:true
        },

      }
    );

  }

  bindEvents() {

    this.addEventListener(
      'change',
      async (e)=>{

        if(
          !e.target.classList.contains(
            'sample-checkbox'
          )
        ) return;

        const input = e.target;

        const variantId =
          input.value;

        const card =
          this.querySelector(
            '.samples-loading'
          );

        const checked =
          this.querySelectorAll(
            '.sample-checkbox:checked'
          );

        if(
          checked.length >
          this.maxAllowed
        ){

          input.checked = false;
          return;

        }

        this.showLoader(card);

        try{

          if(input.checked){

            await this.addToCart(
              variantId
            );

          }else{

            await this.removeFromCart(
              variantId
            );

          }

          this.updateDisabledState();

        }catch(error){

          console.error(error);

          input.checked =
            !input.checked;

        }

        this.hideLoader(card);

      }
    );

  }

  async addToCart(variantId) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: {
                free_sample: 'true'
              }
            }
          ]
        })
      });

      cartPopupUpdate();
      
    } catch (error) {
      console.error('Add to cart failed:', error);
    }
  }
  async removeFromCart(variantId) {
    try {
      const cart = await fetch('/cart.js')
        .then(r => r.json());

      let itemIndex = cart.items.findIndex(
        item => item.variant_id == variantId
      );

      if (itemIndex === -1) return;

      // Shopify line items are 1-based
      itemIndex += 1;

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          line: itemIndex,
          quantity: 0
        })
      });

      cartPopupUpdate();

    } catch (error) {
      console.error('Remove from cart failed:', error);
    }
  }
  showLoader(card){

    card.classList.remove(
      'hidden'
    );

  }

  hideLoader(card){

    card.classList.add(
      'hidden'
    );

  }

  updateDisabledState(){

    const checked =
      this.querySelectorAll(
        '.sample-checkbox:checked'
      );

    const limitReached =
      checked.length >=
      this.maxAllowed;

    this.querySelectorAll(
      '.sample-checkbox'
    ).forEach(
      checkbox=>{

      const card =
        checkbox.closest(
          '.sample-card'
        );

      if(
        limitReached &&
        !checkbox.checked
      ){

        checkbox.disabled =
          true;

        card.classList.add(
          'disabled'
        );

      }else{

        checkbox.disabled =
          false;

        card.classList.remove(
          'disabled'
        );

      }

    });

    this.counter.textContent =
      checked.length;

  }

  bindDrawer(){

    this.addEventListener(
      'click',
      (e)=>{

        const button =
          e.target.closest(
            '.view-more'
          );

        if(!button) return;

        const card =
          button.closest(
            '.sample-card'
          );

        if(!card) return;

        const title =
          card.querySelector(
            '.sample-title'
          )?.textContent?.trim();

        const image =
          card.querySelector(
            '.sample-image img'
          )?.src;

        const description =
          card.querySelector(
            '.sample-description'
          )?.innerHTML;

        this.openDrawer({
          title,
          image,
          description
        });

      }
    );

    this.drawer
      .querySelector(
        '.drawer-close'
      )
      ?.addEventListener(
        'click',
        ()=>this.closeDrawer()
      );

    this.overlay
      ?.addEventListener(
        'click',
        ()=>this.closeDrawer()
      );

  }

  openDrawer(data){

    this.drawer.querySelector(
      '#drawerTitle'
    ).textContent =
      data.title;

    this.drawer.querySelector(
      '#drawerImage'
    ).src =
      data.image;

    this.drawer.querySelector(
      '#drawerDescription'
    ).innerHTML =
      data.description;

    this.drawer.classList.add(
      'active'
    );

    this.overlay.classList.add(
      'active'
    );

    document.body.classList.add(
      'overflow-hidden'
    );

  }

  closeDrawer(){

    this.drawer.classList.remove(
      'active'
    );

    this.overlay.classList.remove(
      'active'
    );

    document.body.classList.remove(
      'overflow-hidden'
    );

  }

}

customElements.define(
  'sample-products',
  SampleProducts
);